export const getMin = (items, key) => {
  if (!Array.isArray(items)) return 0;
  let min = -1;
  items.forEach((item) => {
    const value = item[key];
    if (min === -1 && value != null) min = value;
    if (value != null && value < min) min = value;
  });
  return min;
};

export const getMax = (items, key) => {
  if (!Array.isArray(items)) return 0;
  let max = -1;
  items.forEach((item) => {
    const value = item[key];
    if (max === -1 && value != null) max = value;
    if (value != null && value > max) max = value;
  });
  return max;
};

export const getValues = (items, key) => {
  if (!Array.isArray(items)) return [];
  const values = [];
  items.forEach((item) => {
    if (item[key] && !values.includes(item[key])) values.push(item[key]);
  });
  return values;
};

export const getStatusClassName = (status) => {
  const key = status?.toLowerCase?.();

  switch (key) {
    case "pending":
      return "status-pill status-pending";
    case "measured":
      return "status-pill status-measured";
    case "completed":
      return "status-pill status-completed";
    case "cancelled":
      return "status-pill status-cancelled";
    case "active":
      return "status-pill status-active";
    default:
      return "status-pill status-default";
  }
};

export const formatDate = (dateString) =>
  dateString ? new Date(dateString).toLocaleDateString("hu-HU") : "--";
